import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GithubService } from '../../service';

export type VulnerabilityScanningStatusConfig = typeof VulnerabilityScanningStatusConfig._.Config;

export const VulnerabilityScanningStatusConfig = IntegrationConfig.make({
  service: GithubService,
  name: Integration_Handler_Names_Enum.VulnerabilityScanningStatus,
  configSchema: z.object({
    repositoryNames: z.array(z.string().min(1)).min(1),
  }),
});
